// custom fonts lookup
const spageGoogleFonts = {
  'merriweather,serif': 'Merriweather:300,400,700',
  'droid serif,serif': 'Droid+Serif:300,400,700',
  'noto sans tc,sans-serif': 'Noto+Sans+TC:300,400,700',
  'noto sans jp,sans-serif': 'Noto+Sans+JP:300,400,700',
  'noto sans kr,sans-serif': 'Noto+Sans+KR:300,400,700',
  'Yrsa,Times': 'Yrsa:300,400,500,600',
  'Source Serif Pro,Times': 'Source+Serif+Pro:400,600,700',
  'Cormorant Garamond,Times': 'Cormorant+Garamond:300,300i,400,400i,700,700i',
  'Enriqueta,Times': 'Enriqueta:400,700',
  'Noto Serif,Times': 'Noto+Serif:400,700',
  'Noticia Text,Times': 'Noticia+Text:400,400i,700,700i',
  'Playfair Display,Times': 'Playfair+Display:400,400i,700,700i,900,900i',
  'Alegreya,Times': 'Alegreya:400,400i,500,500i,700,700i',
  'Crimson Text,Times': 'Crimson+Text:400,400i,700,700i',
  'Roboto Slab,Georgia': 'Roboto+Slab:300,400,700',
  'Arvo,Georgia': 'Arvo:400,400i,700,700i',
  'Crete Round,Georgia': 'Crete+Round:400,400i',
  'Roboto,Arial,Helvetica': 'Roboto:300,400,700',
  'Open Sans,Arial,Helvetica': 'Open+Sans:300,400,600,700',
  'Montserrat,Arial,Helvetica': 'Montserrat:400,700',
  'ASAP,Arial,Helvetica': 'Asap:400,400i,700,700i',
  'Nunito,Arial,Helvetica': 'Nunito:300,300i,400,400i,700,700i,900,900i',
  'Ruda,Arial,Helvetica': 'Ruda:400,700,Black',
  'Raleway,Arial,Helvetica': 'Raleway:300,300i,400,400i,600,600i,700,700i,900,900i',
  'Play,Arial,Helvetica': 'Play:400,700',
  'Lato,Arial,Helvetica': 'Lato:300,400,700',
  'Oswald,Arial,Helvetica': 'Oswald:200,300,400,500,700',
  'Open Sans Condensed,Arial,Helvetica': 'Open+Sans+Condensed:300,300i,700',
  'Roboto Condensed,Arial,Helvetica': 'Roboto+Condensed:300,300i,400,400i,700,700i',
  'Economica,Arial,Helvetica': 'Economica:400,400i,700,700i',
  'BioRhyme,Georgia': 'BioRhyme:300,400,700',
  'Caveat,Times': 'Caveat:400,700',
  'Gaegu,Times': 'Gaegu:300,400,700',
  'Amatic SC': 'Amatic+SC:400,700',
  'IM Fell English': 'IM+Fell+English:400,400i',
};

export default function getSpageGoogleFontsLink(theme = {}) {
  const fonts = new Set();
  const _addFonts = themeEntity => {
    const fontFamily = theme[themeEntity]?.fontFamily;
    if (fontFamily && spageGoogleFonts[fontFamily]) {
      fonts.add(spageGoogleFonts[fontFamily]);
    }
  };
  ['surveyTitle', 'questionTitle', 'questionBody', 'button', 'error', 'pageTitle'].forEach(_addFonts);
  if (fonts.size > 0) {
    return `https://fonts.googleapis.com/css?family=${[...fonts].join('|')}`;
  }
  return null;
}
